export default "__VITE_ASSET__uGJcWMSQ__"